import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MediaDto } from '@app/core/models/media.model';
import { EnvironmentService } from '@app/core/services/environment-service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileUploadService {
    private http = inject(HttpClient);
    private environmentService = inject(EnvironmentService);

    uploadFile(file: Blob, relativePath: string): Observable<MediaDto> {
        // Set the parameters when provided
        const formData = new FormData();
        formData.append('file', file, relativePath);
        return this.http.post<MediaDto>(`${this.environmentService.apiURL}/media`, formData);
    }
}
